import { HFlow } from 'bold-ui'
import { DateField } from 'components/form'
import React, { Fragment } from 'react'
import { toDate } from 'util/date/formatDate'
import { MetaPath } from 'util/metaPath'

import { ResultadoExameComSolicitacaoModel, ResultadoExameEspecificoModel, ResultadoExameQueryModel } from '../../model'
import { addPrefix, isExameEspecifico } from '../../util'
import { CardResultadoExameContainer } from '../components/CardResultadoExameContainer'
import { ResultadoExameTextAreaField } from '../components/ResultadoExameTextAreaField'
import { ResultadoExameEspecificoField } from '../exames-especificos/ResultadoExameEspecificoField'

interface ResultadoExameComSolicitacaoFieldProps {
  name: MetaPath<ResultadoExameComSolicitacaoModel> | MetaPath<ResultadoExameEspecificoModel>
  resultadoExame: ResultadoExameQueryModel
}

export const ResultadoExameComSolicitacaoField = (props: ResultadoExameComSolicitacaoFieldProps) => {
  const { name, resultadoExame } = props

  const isEspecifico = isExameEspecifico(resultadoExame.exame)

  const internalName = name[addPrefix(resultadoExame.id)]

  return (
    <CardResultadoExameContainer exame={resultadoExame.exame}>
      {isEspecifico ? (
        <ResultadoExameEspecificoField
          name={internalName as MetaPath<ResultadoExameEspecificoModel>}
          exame={resultadoExame.exame}
          hasSolicitacao
        />
      ) : (
        <Fragment>
          <ResultadoExameTextAreaField name={internalName.resultado} />

          <HFlow hSpacing={1.5}>
            <DateField
              name={internalName.dataRealizado}
              label='Realizado em'
              minDate={toDate(resultadoExame.solicitacao.data)}
              maxDate={new Date()}
            />

            <DateField name={internalName.dataResultado} label='Resultado em' maxDate={new Date()} />
          </HFlow>
        </Fragment>
      )}
    </CardResultadoExameContainer>
  )
}
